import { useCallback, useState } from 'react'
import useFieldFocus from '@v4/hooks/useFieldFocus'
import useRepeatableMetaData from '@v4/hooks/useRepeatableMetaData'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import useStyles from './Item.styled'

export const useItem = props => {
	const { group, index, itemKey } = props
	const metaData = useRepeatableMetaData({ group, index })
	const [open, setOpen] = useState(false)
	const classes = useStyles(props)

	const { handleFocus: handleClick } = useFieldFocus({ metaData: { config: { group } }, index, itemKey })
	const { handleFocus: handleTitleClick } = useFieldFocus({ metaData: metaData.itemTitle, index, itemKey })
	const { handleFocus: handleTextClick } = useFieldFocus({ metaData: metaData.itemText, index, itemKey })

	const { editable: titleEditable, handleChange: handleTitleChange } = useEditorMeta({
		metaData: metaData.itemTitle,
		key: 'itemTitle',
		index,
	})

	const handleItemClick = useCallback(
		event => {
			handleClick?.(event)
			setOpen(prev => !prev)
		},
		[handleClick],
	)

	const { editable: textEditable, handleChange: handleTextChange } = useEditorMeta({
		metaData: metaData.itemText,
		key: 'itemText',
		index,
	})

	return [
		{
			open,
			classes,
			group,
			itemKey,

			title: metaData.itemTitle?.metaValue,
			titleConfig: metaData.itemTitle?.config,
			titleKey: metaData.itemTitle?.tierKey,
			titleEditable,

			text: metaData.itemText?.metaValue,
			textConfig: metaData.itemText?.config,
			textKey: metaData.itemText?.tierKey,
			textEditable,
		},
		{
			handleClick: handleItemClick,

			handleTitleChange,
			handleTitleClick,

			handleTextChange,
			handleTextClick,
		},
	]
}
